<template>
    
    <PriceListTable 
        :priceList="priceList" 
        :paginator="paginator" 
        :pageSize="pageSize"  
        @get-price-list-empresa="getPriceListEmpresa()" 
        @change-page="changePage($event)" 
        @update-status-price-list="updateStatusPriceList($event)"
    />
    
</template>
<script>
import { mapMutations } from 'vuex'
import PriceListTable from '../components/PriceListTable.vue'
export default {
    data(){
        return{
            priceList: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: {},
        }
    },
    components: {
        PriceListTable
    },
    created(){
        this.getPriceListEmpresa();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPriceListEmpresa(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize: this.paginator.pageSize,
            }
            this.setLoading(true)
            await this.$conectar.post('/empresa/price-list/get-price-list-empresa', this.pageOptions)
            .then(response =>{
                this.priceList = response.data.priceListEmpresa;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getPriceListEmpresa();
        },
        async updateStatusPriceList(item){
            item.status = !item.status
            this.data = {price_list_id: item.id, status: item.status}
            this.setLoading(true)
            await this.$conectar.post('/empresa/price-list/update-status-price-list', this.data)
            .then(response =>{
                if(response.data.error == true){
                    item.status = !item.status;
                    this.$bvToast.toast(response.data.errorMessage, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e);
                item.status = !item.status;
                this.$bvToast.toast("Parece que hubo un error en el servidor, por favor intente mas tarde, si el problema persiste, contacte al administrador.", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                
            })
            this.setLoading(false)
        }
    }
}
</script>